import type { Country } from '@/helpers/country-codes'
import { includes } from '@/helpers'

export const supportedFlags: Country[] = ['CA', 'ZA']

export type SupportedFlag = (typeof supportedFlags)[number]

export function isSupportedFlag(
    countryCode: Country
): countryCode is SupportedFlag {
    return includes(supportedFlags, countryCode)
}
